module.exports = __webpack_public_path__ + "img/1x.4ed1d0e.jpg";